// extracted by mini-css-extract-plugin
export default {"wrapper":"PrepayRequireDialog--wrapper--b90376","content":"PrepayRequireDialog--content--74b76d","buttonSpacing":"PrepayRequireDialog--buttonSpacing--a26e24"};